import ChartApi from '../../apis/charts';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { isErrorWithMessage } from '../../helper';
import { resettingChartLoader } from '../slices/chart';
import { RootState } from '../../redux/store';

export const fetchAgencysClientAnalyticsThunk = createAsyncThunk(
    'chart/agency-client-analytics',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ChartApi.fetchAgencysClientAnalytics(state.app.token);
            if (response?.success === 1) {
                return response;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingChartLoader());
        }
    }
);

export const fetchSalesAnalyticsDataThunk = createAsyncThunk(
    'chart/agency-analytics',
    async (time: 'All time' | 'Last 6 months' | 'Last 3 months' | 'Last month' | 'Last week', { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ChartApi.fetchAnalyticsDataForSales(state.app.token, time);
            if (response?.success === 1) {
                return response;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingChartLoader());
        }
    }
);

export const fetchCustomerAnalyticsDataThunk = createAsyncThunk(
    'chart/customer-analytics',
    async (time: 'All time' | 'Last 6 months' | 'Last 3 months' | 'Last month' | 'Last week', { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ChartApi.fetchAnalyticsDataForCustomer(state.app.token, time);
            if (response?.success === 1) {
                return response;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingChartLoader());
        }
    }
);

export const fetchDealsBreakDownForSalesThunk = createAsyncThunk(
    'chart/deals-breakdown',
    async (time: 'All time' | 'Last 6 months' | 'Last 3 months' | 'Last month' | 'Last week', { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ChartApi.fetchDealsBreakDownForSales(state.app.token, time);
            if (response?.success === 1) {
                return response?.deal_breakdown;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingChartLoader());
        }
    }
);
